<template>
  <div class="disable-text-selection">
    <b-row class="survey-app" >
      <b-colxx xxs="12" lg="12" v-if="isLoadSurveys" key="surveyDetail">
          <h1 v-if="currentPatient" >
            <i class="simple-icon-user mr-1"></i>
            <span class="align-middle d-inline-block pt-1">{{currentPatient.name}}</span>
          </h1>
          <b-card class="w-100" v-if="!currentPatient" no-body>
            <b-card-body class="text-center p-4">
                <h5 class="card-title mb-0">Patient non trouvé.</h5>
            </b-card-body>
          </b-card> 
          <b-tabs nav-class="separator-tabs ml-0 mb-5" content-class="tab-content" v-model="step" :no-fade="true"  v-if="currentPatient" key="itemList">
            <b-tab :title="'Details'" >
              <b-row>
              <b-colxx xxs="12" sm="4" class="mb-4">
                <b-card class="mb-4" no-body>
                    <b-card-body>
                      <p class="list-item-heading mb-4">{{"Resumé"}}</p>
                      <p class="text-muted text-small mb-2">{{"Nom Complet:"}}</p>
                      <p class="mb-3">{{currentPatient.name}}</p>
                      <p class="text-muted text-small mb-2">{{"CIN:"}}</p>
                      <p class="mb-3" v-html="currentPatient.cin"/>
                      <p class="text-muted text-small mb-2">{{"Telephone:"}}</p>
                      <p class="mb-3">{{currentPatient.phone}}</p>
                      <p class="text-muted text-small mb-2">{{"Email"}}</p>
                      <p class="mb-3">{{currentPatient.email}}</p>

                    </b-card-body>
                </b-card>
              </b-colxx>
              <b-colxx xxs="12" sm="8">
                <div class="text-left">
                    <b-button variant="outline-primary" @click="addOperation"><i class="simple-icon-plus btn-group-icon" /> {{"Ajouter une operation"}}</b-button>
                      <datepicker
                        class="form-control"
                        v-model="dateFilter"
                        :language="fr"
                        placeholder="Date"
                        :clear-button="true"
                        clear-button-icon="iconsminds-close"
                        @cleared="dateFilter = null"
                      ></datepicker>
                </div>
                <div class="sortable-survey mt-3" v-if="filtredOperations && filtredOperations.length">
                    <patient-operations v-for="(operation,index) in filtredOperations" :key="`operation_${index}`" :id="operation.id" :data="operation" :sort="index+1"/>
                </div>
                <b-card class="w-100 mt-3" v-if="!filtredOperations.length" no-body>
                  <b-card-body class="text-center p-4">
                    <h5 class="card-title mb-0">Aucune opération trouvé.</h5>
                  </b-card-body>
                </b-card> 
              </b-colxx>
              </b-row>
            </b-tab>
            <b-tab :title="'Documents Attachées'">
              <!-- <b-row>
                <b-colxx xxs="12" lg="12">
                  <PatientAttachedFiles></PatientAttachedFiles>
                </b-colxx>
              </b-row> -->
              <b-row v-if="false">
                <b-colxx xxs="12" md="6" lg="6" xl="3">
                  <div class="card upload-container w-100 mb-4" @click="((!startImageProgress || imagesUploadFinished) && !loadMedia) ? openFilesChosser() : doNothing()">
                    <div v-if="(!startImageProgress || imagesUploadFinished) && !loadMedia">
                      <input type="file" ref="attachmentFile" @change="loadFiles" multiple @click="clearInput($event)" hidden>
                      <svg class="upload-container__icon" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                          viewBox="0 0 477.867 477.867" style="enable-background:new 0 0 477.867 477.867;" xml:space="preserve">
                          <path fill="#064962" d="M324.267,221.867H256V153.6c0-9.426-7.641-17.067-17.067-17.067s-17.067,7.641-17.067,17.067v68.267H153.6
                            c-9.426,0-17.067,7.641-17.067,17.067S144.174,256,153.6,256h68.267v68.267c0,9.426,7.641,17.067,17.067,17.067
                            S256,333.692,256,324.267V256h68.267c9.426,0,17.067-7.641,17.067-17.067S333.692,221.867,324.267,221.867z"/>
                      </svg>
                    </div>
                    <div class="w-100 h-100" v-else>
                      <!-- <vue-loaders-ball-beat  /> -->
                      <vue-loaders-ball-beat class="display-table-cell upload-container__loader" v-if="loadMedia" color="#317ffe" scale="1.2"></vue-loaders-ball-beat>
                      <div class="upload-container__upload" v-else>
                        <p class="upload-container__upload--text">Téléchargement ( {{currentIndex+1}} / {{images.length}} ) ...</p>
                        <b-progress style="height:28px;border: 2px solid #317ffe;" >
                          <b-progress-bar :value="images[currentIndex].progress" variant="theme-5"></b-progress-bar>
                        </b-progress>
                      </div>
                    </div>
                  </div>
                </b-colxx>
                <b-colxx v-for="(attach,indexAttach) in mediaListPhotos" :key="indexAttach" xxs="12" md="6" lg="6" xl="3">
                  <div class="card files__container mb-4 overflow-hidden">
                    <img style="width:100%;" :src="backendUrl+attach">
                  </div>
                </b-colxx>
              </b-row>

              <b-row>
                <b-colxx class="p-2" xxs="12" md="6" lg="6" xl="3">
                  <!-- mb-4 -->
                  <div class="card upload-container w-100" @click="((!startImageProgress || imagesUploadFinished) && !loadMedia) ? openFilesChosser() : doNothing()">
                    <div v-if="(!startImageProgress || imagesUploadFinished) && !loadMedia">
                      <input type="file" ref="attachmentFile" @change="loadFiles" multiple @click="clearInput($event)" hidden>
                      <svg class="upload-container__icon" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                          viewBox="0 0 477.867 477.867" style="enable-background:new 0 0 477.867 477.867;" xml:space="preserve">
                          <path fill="#064962" d="M324.267,221.867H256V153.6c0-9.426-7.641-17.067-17.067-17.067s-17.067,7.641-17.067,17.067v68.267H153.6
                            c-9.426,0-17.067,7.641-17.067,17.067S144.174,256,153.6,256h68.267v68.267c0,9.426,7.641,17.067,17.067,17.067
                            S256,333.692,256,324.267V256h68.267c9.426,0,17.067-7.641,17.067-17.067S333.692,221.867,324.267,221.867z"/>
                      </svg>
                    </div>
                    <div class="w-100 h-100" v-else>
                      <!-- <vue-loaders-ball-beat  /> -->
                      <vue-loaders-ball-beat class="display-table-cell upload-container__loader" v-if="loadMedia" color="#317ffe" scale="1.2"></vue-loaders-ball-beat>
                      <div class="upload-container__upload h-100" v-else>
                        <p class="upload-container__upload--text">Téléchargement ( {{currentIndex+1}} / {{images.length}} ) ...</p>
                        <b-progress style="height:28px;border: 2px solid #317ffe;" >
                          <b-progress-bar :value="images[currentIndex].progress" variant="theme-5"></b-progress-bar>
                        </b-progress>
                      </div>
                    </div>
                  </div>
                </b-colxx>
                <!-- mb-4  -->
                <b-colxx class="p-2" v-for="(attach,indexAttach) in mediaListPhotos" :key="indexAttach" xxs="12" md="6" lg="6" xl="3">
                  <div class="card files__container overflow-hidden">
                    <div class="files__container--img" style="width:100%;" :style="{background:`url('${attach}')`}"></div>
                  </div>
                </b-colxx>
              </b-row>
            </b-tab>
        </b-tabs>
        
      </b-colxx>
      <div v-else class="loading" key="itemLoading"></div>
    </b-row>
  </div>
</template>
<script>
// import PatientAttachedFiles from './PatientAttachedFiles.vue'
import Vue from "vue";
import Datepicker from "vuejs-datepicker";
import PatientOperations from './PatientOperationsList'
import { apiUrl } from "@/constants/config";
import moment from 'moment'
import { fr } from "vuejs-datepicker/dist/locale";

import 'vue-loaders/dist/vue-loaders.css';
import VueLoaders from 'vue-loaders';

Vue.use(VueLoaders);

export default {
  components: {
    PatientOperations,
    // PatientAttachedFiles,
    Datepicker
  },
  data () {
    return {
      fr:fr,
      dateFilter:new Date(),
      categories: [
        { label: 'Development', value: 'Development' },
        { label: 'Workplace', value: 'Workplace' },
        { label: 'Hardware', value: 'Hardware' }
      ],
      labels: [
        { label: 'EDUCATION', value: 'EDUCATION', color: 'secondary' },
        { label: 'NEW FRAMEWORK', value: 'NEW FRAMEWORK', color: 'primary' },
        { label: 'PERSONAL', value: 'PERSONAL', color: 'info' }
      ],
      statuses: [
        { text: 'ACTIVE', value: 'ACTIVE' },
        { text: 'COMPLETED', value: 'COMPLETED' }
      ],
      currentPatient: null,
      isLoadSurveys:false,
      backendUrl:apiUrl,
      images:[],
      imagesProgress:[],
      mediaListPhotos:[],
      step:0,
      listImages:[],
      startImageProgress:false,
      loadMedia:false,
      imagesUploadFinished:false,
      currentIndex:0
    }
  },
  computed: {
    droppedFiles(){
      return this.$store.getters.getDroppedFilesByType('patient');
    },
    filtredOperations(){
      if(this.dateFilter){
        return this.currentPatient.operations.filter((res) => {
          let have = false
          let date = moment(this.dateFilter)
          for(let i=0;i<res.rdvs.length;i++){
            let currentDate = moment(res.rdvs[i].date)
            let dt = currentDate.diff(date, 'days')
            if(dt == 0){
              have = true
            }
          }
          if(!res.rdvs.length){
            have = true
          }
          return have;
        });
      }
      else{
        return this.currentPatient.operations
      }
    }
  },
  methods: {
    onDrop(event){
      let files = event.dataTransfer.files;
      this.loadFiles(files);
    },
    doNothing(){
      return
    },
    openFilesChosser(){
      this.$refs.attachmentFile.click()
    },
    loadFiles(data) {
      var files = null
      this.loadMedia = true
      if(data.type && data.type == "change"){
        files = this.$refs.attachmentFile.files;
      }
      else{
        files = data
      }
      if(files.length){
        for (var i = 0; i < files.length; i++) {
          // mp4|mkv|avi|
          if (!/\.(jpg|png|jpeg)$/i.test(files[i].name)) {
            // this.notify("error",this.$t('errors.file_type_not_supported'));
            this.$notify('error filled', '', "format de fichier non pris en charge, essayez les fichiers jpg, jpeg ou png.", { duration: 5000, permanent: false })
            this.loadMedia = false
            return;
          }
        }
        this.images = []
        this.saveFiles(files,0)
      }
      else{

          this.loadMedia = false
          return
      }
    },
    saveFiles(files,index){
            var file = files[index]
            var reader = new FileReader(file);
            // var formData = file
            reader.onloadend = async (event) => {
                var part = event.target.result.split(";base64,");
                var secondpart = part[0].split(":");
                if(secondpart[1].includes("image")){
                    var image = {};
                    image.name = file.name
                    image.blob = event.target.result;
                    image.size = event.total;
                    image.progress = 0;
                    image.file = file
                    image.uploaded = false;
                    image.type = secondpart[1];
                    this.images.push(image);
                    this.imagesProgress.push(0)
                }
                this.startImageProgress=false
                if(index == files.length-1){
                    this.loadMedia = false
                    this.startImageProgress=true
                }
            }
            reader.readAsDataURL(file);
            if(files[index+1]){
                setTimeout(()=>{
                    this.saveFiles(files,index+1)}
                ,800)
            }
            else{
                setTimeout(()=>{
                    this.uploadFiles()
                },1000)
            }

    },
    uploadFiles(){
      if(this.images.length){
          this.uploadImages()
      }
      if(!this.images.length){
          this.imagesUploadFinished = true
      }
    },
    async uploadImages(){
        this.startImageProgress = true
        this.imagesUploadFinished = false
        this.listImages = []
        for(var j=0;j<this.images.length;j++){
            if(!this.images[j].uploaded && !this.images[j].link && !this.images[j].started){
                this.images[j].started = true
                let images = this.images[j].file
                this.currentIndex = j
                try {
                    let endpoint = `${apiUrl}/patients/id/${this.currentPatient.id}/attachments`;
                    
                    let obj = {image:images,folder:"patients"}
                    let data = new FormData();
                    for(let key in obj){
                        data.append(key,obj[key]);
                    }

                    this.$axios.defaults.headers.common["X-Access-Token"] = this.$store.state.accessToken;
                    const resultUpload = await this.$axios.put(endpoint,data,{
                        onUploadProgress: progressEvent => {
                            if(this.images[j] && this.imagesProgress[j] !== null && this.imagesProgress[j] !== undefined  ){
                                this.imagesProgress[j] = parseInt(
                                Math.round((progressEvent.loaded * 100) / progressEvent.total)
                                );
                                this.images[j].progress = this.imagesProgress[j]
                            }
                        }
                    })
                    delete this.$axios.defaults.headers.common["X-Access-Token"];
                    console.log("resultUpload",resultUpload)
                    if(resultUpload){
                      let result = resultUpload.data
                      this.mediaListPhotos = result
                      this.images[j].finished = true
                    }
                    else{
                      this.images[j].finished = true
                      this.images[j].failed = true
                    }
                } catch (err){
                      this.images[j].finished = true
                      this.images[j].failed = true
                    this.imagesProgress[j] = 0
                    delete this.$axios.defaults.headers.common["X-Access-Token"];
                    return err;
                }
            }
        }
        setTimeout(() => {
          for(var i=0;i<this.listImages.length;i++){
              let item = this.mediaListPhotos.findIndex(obj => parseInt(obj) == parseInt(this.listImages[i]))
              if(item == -1 ){
                  this.mediaListPhotos.unshift(this.listImages[i])
              }
          }
          this.imagesUploadFinished = true
          this.startImageProgress = false
          delete this.$axios.defaults.headers.common["X-Scalify-Token"];
        }, 3000)
    },
    clearInput(event){
      event.target.value = ""
    },
    addOperation () {
        this.currentPatient.operations.push({
            index: this.currentPatient.operations.length + 1,
            description: 'Operation',
            prixtotale:"0",
            nb_rdv:"1",
            showDetail:true,
            rdvs:[]
        })
        this.$forceUpdate()
    },
    getPatientDetails(){
    //   this.isLoad = false;
      let currentEndpoint = `${apiUrl}/patients/id/${this.$route.params.id}`
      this.sendRequest('get',currentEndpoint)
      .then(res => {
        console.log("reees",res)
        // this.listPatients = res.data
        if(res.data !== ""){       
            this.currentPatient = res.data
            // this.currentPatient.operations = []
            this.mediaListPhotos = JSON.parse(this.currentPatient.attachments);
        }
        this.isLoadSurveys = true
        // this.isLoad = true;
      }).catch(err=>{
        // this.isLoad = true;
        console.log("iam the error",err)
      })
    },

  },
  mounted () {
    this.getPatientDetails()
  },
  watch: {
    droppedFiles:{
      deep:true,
      handler(){
        if(this.droppedFiles.length && this.step == 2){
          let event = {dataTransfer:{files:[...this.droppedFiles]}}
          this.onDrop(event)
        }
      }
    },
    step(){
      if(this.step == 2){
        this.$store.state.isUploadTab = true
      }
      else{
        this.$store.state.isUploadTab = false
      }
    }
  }
}
</script>
<style lang="scss">
.vdp-datepicker {
  display: inline-block;
  width: auto;
  margin-left: 15px;
  border-radius: 5px;
  input {
    border: 0;
    width: calc(100% - 25px);
  }
}

.files__container{
  height: 100%;
  min-height:180px;
  cursor: pointer;
  border: 1px solid #DDDDDD;
  .files__container--img{
    height: 100%;
    background-color: transparent !important;
    background-size: contain !important;
    background-position: center !important;
    background-repeat: no-repeat !important;
  }
}
.upload-container{
  padding:20px;
  cursor:pointer;
  border: 2px dashed #064962;
  position:relative;
  // min-height: 50%;
  min-height:180px;
  .upload-container__icon{
    display: block;
    width:75%;
    height:75%;
    margin:auto;
  }
  .upload-container__loader{
    position:absolute;
    left:50%;
    top:50%;
    transform: translate(-50%,-50%) scale(1.2) !important;
  }
  .upload-container__upload{
    position:absolute;
    left:50%;
    top:50%;
    transform: translate(-50%,-50%) !important;
    width: calc(100% - 40px);
    max-height: calc(100% - 40px);
    .upload-container__upload--text{
      font-weight: bold;
      text-align: center;
      font-size: 16px;
    }
  }
}
</style>
